module.exports = __webpack_public_path__ + "img/traffic-flow.f5eabbf9.svg";